module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "ql-new-layer-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addLayer($event)
      }
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Add a New Layer")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Layer Title")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newLayerTitle),
      callback: function($$v) {
        _vm.newLayerTitle = $$v
      },
      expression: "newLayerTitle"
    }
  })], 1), _vm._v(" "), _c('color-picker', {
    staticClass: "ql-color-picker",
    on: {
      "input": _vm.pickColor
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.addLayer
    }
  }, [_vm._v("Add Layer")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fccd5a72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/layers/layer-new.vue
// module id = 686
// module chunks = 2